// @ts-check
import { gql } from '@apollo/client';
import { Image } from '@react-pdf/renderer';
import React from 'react';
import { Box, Page, Text, Title } from '../../../pdf-design-system';
import { Separator } from './VieVinumMyList';
import { theme } from './VieVinumMyListTable';

/**
 *
 * @param {{ data: import('./@types/VieVinumMyListCover').VieVinumMyListCoverFragment; user: import('firebase/auth').User }}props
 * @returns
 */
export default function VieVinumMyListCover({ data, user }) {
  const { collection } = data;
  return (
    <Page size="A4" theme={theme}>
      <A5Box>
        {collection?.logo?.fixed?.src && (
          <Image
            src={collection.logo.fixed.src}
            style={{ width: '70mm', paddingBottom: '5mm' }}
          />
        )}
        <Title variant="cover">Hofburg Vienna</Title>
        <Title variant="coverSmall">21.–23. Mai 2022</Title>
      </A5Box>
      <Separator />
      <A5Box>
        <Text variant="cover" style={{ marginTop: '4cm' }}>
          {user?.displayName || '(kein Name)'}
        </Text>
        <Text variant="cover">{user?.email || '(keine E-Mail)'}</Text>
        <Text
          variant="cover"
          style={{ marginTop: '3cm', marginBottom: '10mm' }}
        >
          Meine Liste,{' '}
          {new Date().toLocaleDateString('de', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
          })}
        </Text>
      </A5Box>
      <React.Fragment />
    </Page>
  );
}

function A5Box({ children, ...rest }) {
  return (
    <Box
      style={{
        display: 'flex',
        textAlign: 'right',
        paddingHorizontal: '15mm',
        paddingTop: '10mm',
        paddingBottom: '10mm',
        height: '148.5mm',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}

/** @type {import('@apollo/client').TypedDocumentNode<import('./@types/VieVinumMyListCover').VieVinumMyListCoverFragment>}*/
VieVinumMyListCover.fragment = gql`
  fragment VieVinumMyListCover on CatalogConfiguration {
    catalogConfigurationId
    collection {
      logo {
        # 50mm in 300dpi
        fixed(width: 590, crop: PAD, gravity: NORTH, fetch_format: JPG) {
          src
          width
          height
        }
      }
      # needed for Apollo Client
      ... on Event {
        eventId
      }
    }
  }
`;
